import React from 'react'
import './SkillCards.css'

const SkillCards = (props) => {
  return (
    <div className="skill-card">
      <div className="skill-head">
        <span className="skill-name">{props.name}</span>
        <span className="skill-pct">{props.pct}%</span>
      </div>
      <div className="bar-track">
        <div className="bar-fill" style={{ width: `${props.pct}%` }}></div>
      </div>
      <div className="skill-cat">{props.category}</div>
    </div>
  )
}

export default SkillCards
